import Highscore from "../../contracts/Highscore.json";
import addresses from "../../contracts/addresses.json";

const state = {
  abi: null,
  address: null,
  contract: null,
  entries: null,
  topScore: 0
};

const getters = {
  getAbi(state) {
    return state.abi;
  },
  getAddress(state) {
    return state.address;
  },
  getContract(state) {
    return state.contract;
  },
  getEntries(state) {
    return state.entries;
  },
  getTopScore(state) {
    return state.topScore;
  }
};

const actions = {
  async fetchContract({ commit, rootState }) {
    let web3 = rootState.accounts.web3;
    let chainIdDec = parseInt(rootState.accounts.chainId);

    let address = addresses.Highscore[chainIdDec];

    let contract = new web3.eth.Contract(Highscore.abi, address);
    commit("setContract", contract);
  },
  async fetchEntries({ commit, dispatch, rootState, state }) {
    if (!state.contract) {
      dispatch("fetchContract");
    }

    const web3 = rootState.accounts.web3;

    // get array length
    const length = await state.contract.methods.getEntriesArrayLength().call();

    // loop through entries
    let entries = [];
    let topScore = 0;
    for (let i = 0; i < length; i++) {
      let entryData = await state.contract.methods.getEntryByIndex(i).call();

      let entryScore = Number(web3.utils.fromWei(entryData[0], "ether"));

      if (entryScore > topScore) {
        topScore = entryScore;
      }

      entries.push({
        score: Number(entryScore),
        title: entryData[1],
        url: entryData[2],
        author: entryData[3]
      });
    }

    entries.sort((a, b) => (b.score - a.score));

    commit("setTopScore", topScore);
    commit("setEntries", entries);
  },
  storeAbi({commit}) {
    commit("setAbi", Highscore.abi);
  },
  storeAddress({ commit, rootState }) {
    let chainIdDec = parseInt(rootState.accounts.chainId);
    let address = addresses.Highscore[chainIdDec];

    commit("setAddress", address);
  }
};

const mutations = {
  setAbi(state, _abi) {
    state.abi = _abi;
  },
  setAddress(state, _address) {
    state.address = _address;
  },
  setContract(state, _contract) {
    state.contract = _contract;
  },
  setEntries(state, _entries) {
    state.entries = _entries;
  },
  setTopScore(state, _score) {
    state.topScore = _score;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
